export default __webpack_public_path__ + "static/media/empty.bcc753d7.png";